export const projects = [
  {
    id: 4,
    name: "Gatstore — Gatsby E-commerce",
    description:
      "A fast, responsive storefront with product discovery and Stripe-powered checkout.",
    url: "https://gatstore.netlify.app/",
    repo: "https://github.com/evinracher/gatstore",
    techs: ["Gatsby", "React", "Stripe", "Styled Components"],
    creationDate: "May 2022",
    images: ["/images/project4_1.png"],
  },
  {
    id: 3,
    name: "Petgram — Social Pet Gallery",
    description:
      "A mobile-first PWA for discovering and sharing pet photography.",
    url: "https://petgram-evinracher.vercel.app/",
    repo: "https://github.com/evinracher/petgram",
    techs: ["React", "GraphQL", "Apollo", "Styled Components", "PWA"],
    creationDate: "May 2022",
    images: ["/images/project3_1.png"],
  },
  {
    id: 2,
    name: "Recipe Finder",
    description:
      "An installable recipe explorer with step-by-step meals from TheMealDB API.",
    url: "https://recipes-app-three.vercel.app/",
    repo: "https://github.com/evinracher/react-recipes-app",
    techs: ["React", "PWA", "Workbox", "MealDB API"],
    creationDate: "April 2022",
    images: ["/images/project2_1.png"],
  },
  {
    id: 6,
    name: "Pokédex Analytics — Angular",
    description:
      "An Angular Pokédex for exploring Pokémon data through search, details, and charts.",
    url: "https://evinracher.github.io/angular-pokemon-app/home",
    repo: "https://github.com/evinracher/angular-pokemon-app",
    techs: ["Angular", "TypeScript", "NgRx", "Angular Material", "Chart.js"],
    creationDate: "November 2020",
    images: ["/images/project6_1.png"],
  },
  {
    id: 5,
    name: "Pokédex Explorer — React",
    description:
      "A responsive React Pokédex with browsable profiles, stats, and data visualizations.",
    url: "https://evinracher.github.io/react-pokemon-app/",
    repo: "https://github.com/evinracher/react-pokemon-app",
    techs: ["React", "Redux", "React Router", "Chart.js"],
    creationDate: "October 2020",
    images: ["/images/project5_1.png"],
  },
  {
    id: 1,
    name: "Talos Frontend Experience",
    description:
      "A responsive landing page built from scratch during my Talos internship.",
    url: "https://evinracher.github.io/fe-project-talos-inc",
    repo: "https://github.com/evinracher/fe-project-talos-inc",
    techs: ["JavaScript", "HTML", "CSS"],
    creationDate: "September 2020",
    images: ["/images/project1_1.png"],
  },
];

export const privateProjects = [
  {
    id: "wsj-plus",
    name: "WSJ+ Subscriber Experiences",
    description:
      "A premium events and experiences platform for Dow Jones publication subscribers.",
    url: "https://www.wsj.com/wsjplus/dashboard/",
    techs: ["React", "TypeScript", "Jest", "RTL", "MSW", "Design Systems"],
    creationDate: "2023 — Present",
    images: ["/images/brands/wsj-plus.svg"],
    client: "The Wall Street Journal",
    private: true,
  },
];
